module.exports = __webpack_public_path__ + "media/day/386-bb4c8c66.svg";